import useEvent from '@lyearn/core/hooks/useEvent';
import { CheckmarkOutline } from '@lyearn/icons';
import { BaseMenuItem, Typography } from '@lyearn/ui';

import { BaseSortMenuItem, SortMenuItemProps } from '../SortMenuItems/types';

const SortMenuItemDesktop = <T extends BaseSortMenuItem>(props: SortMenuItemProps<T>) => {
  const { item, isSelected, onAction } = props;
  const { label, Icon } = item;

  const onClick = useEvent(() => {
    onAction(item);
  });

  return (
    <BaseMenuItem
      className="relative flex h-40 items-center rounded-8 px-12 hover:bg-bg-tertiary"
      onClick={onClick}>
      {Icon ? (
        <Icon
          className="h-20 w-20 flex-shrink-0 me-12"
          fillColorToken={isSelected ? 'icon-active' : 'icon-secondary'}
        />
      ) : null}
      <Typography
        // me-36 -> margin-inline-end for text (16px) +  icon width (20px)
        // added such that size of list doesn't on changing items
        className="flex-1 me-36"
        color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
        variant="body-short-02">
        {label}
      </Typography>
      {isSelected ? (
        <CheckmarkOutline
          className="absolute h-20 w-20 flex-shrink-0 end-12"
          fillColorToken="icon-active"
        />
      ) : null}
    </BaseMenuItem>
  );
};

export default SortMenuItemDesktop;
